exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width: 767px) {\r\n    .ms-footer p {\r\n        text-align: center !important;\r\n    }\r\n    .footercls {\r\n        width: auto !important;\r\n    }\r\n    .footerAdmincls {\r\n        margin-left: auto !important;\r\n    }\r\n}\r\n.block_i {\r\n    display: none;\r\n}\r\n\r\n.footercls {\r\n    width: 19.66%;\r\n}\r\n@media (min-width:990px) and (max-width: 1200px){\r\n    .footercls {\r\n        width: 15rem !important;\r\n    }\r\n    .footerAdmincls {\r\n        margin-left: 0rem !important;\r\n    }\r\n}\r\n.footerAdmincls {\r\n    margin-left: -3rem;\r\n}\r\n\r\n .ms-footbar .ms-footbar-block {\r\n    margin: 0;    \r\n} \r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/layout/footer.component.css
// module id = ../../../../../client/app/shared/layout/footer.component.css
// module chunks = main